import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white flex w-fit items-center gap-1.5 rounded-full px-3 py-2.5 sm:gap-3 sm:px-4 sm:py-2',
    icon: 'text-blue-dark size-6',
    text: 'lg:heading-s text-main heading-xs'
  }
});
